module.exports = __webpack_public_path__ + "static/media/gf.2d9f5857.svg";